<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="358" height="365.992" viewBox="0 0 358 365.992">
    <g id="Gruppe_2749" data-name="Gruppe 2749" transform="translate(-16 -190)">
      <path id="Pfad_4552" data-name="Pfad 4552" d="M179,0A179,179,0,1,1,0,179,179,179,0,0,1,179,0Z"
            transform="translate(16 190)" fill="#2f2f2f"/>
      <line id="Linie_268" data-name="Linie 268" y2="9.832" transform="translate(152.193 391.623)" fill="none"
            stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>
      <line id="Linie_269" data-name="Linie 269" y2="3.982" transform="translate(152.193 406.723)" fill="none"
            stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>
      <path id="Pfad_4016" data-name="Pfad 4016" d="M851.941,2030.828,715.42,2002.408V1844.7l136.521-7.6Z"
            transform="translate(-528.822 -1559.992)" :fill="color"/>
      <line id="Linie_282" data-name="Linie 282" y2="143.733" transform="translate(178.268 275.722)" fill="none"
            stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>
      <rect id="Rechteck_3396" data-name="Rechteck 3396" width="45.668" height="77.43" rx="12"
            transform="translate(66.885 290.643)" :fill="color"/>
      <rect id="Rechteck_3397" data-name="Rechteck 3397" width="45.668" height="77.43" rx="12"
            transform="translate(72.75 285.636)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4"/>
      <circle id="Ellipse_803" data-name="Ellipse 803" cx="6.374" cy="6.374" r="6.374"
              transform="translate(89.211 338.109)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4"/>
      <circle id="Ellipse_804" data-name="Ellipse 804" cx="11.483" cy="11.483" r="11.483"
              transform="translate(84.102 333)" fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="4"/>
      <line id="Linie_305" data-name="Linie 305" y1="2.392" x2="96.841" transform="translate(198.223 320.42)"
            fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>
      <line id="Linie_306" data-name="Linie 306" x2="103.616" y2="3.586" transform="translate(195.434 363.066)"
            fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>
      <line id="Linie_307" data-name="Linie 307" x2="89.269" y2="8.766" transform="translate(198.223 404.112)"
            fill="none" stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>
      <line id="Linie_308" data-name="Linie 308" y2="5.642" transform="translate(314.789 419.455)" fill="none"
            stroke="#fff" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"/>
      <path id="Pfad_4038" data-name="Pfad 4038" d="M810.276,1963.234V1817.52l-162.6,10.193v108.421"
            transform="translate(-495.486 -1550.355)" fill="none" stroke="#fff" stroke-linecap="round"
            stroke-miterlimit="10" stroke-width="4"/>
      <path id="Pfad_3988" data-name="Pfad 3988"
            d="M1.021,5.184,86.537,147.147,5.844,2.361A2.952,2.952,0,1,0,1.021,5.184Z"
            transform="matrix(0.225, -0.974, 0.974, 0.225, 151.672, 503.611)" fill="#fff"/>
      <path id="Pfad_4280" data-name="Pfad 4280" d="M.475,2.412,40.261,68.459,2.719,1.1A1.373,1.373,0,1,0,.475,2.412Z"
            transform="matrix(0.225, -0.974, 0.974, 0.225, 119.238, 540.592)" fill="#fff"/>
      <path id="Pfad_4281" data-name="Pfad 4281"
            d="M21.869,13l-.889,1.98L19,15.869l1.98.889.889,1.98.889-1.98,1.98-.889-1.98-.889Z"
            transform="translate(204.543 225.563)" fill="#fff"/>
      <path id="Pfad_4282" data-name="Pfad 4282"
            d="M22.992,13l-1.237,2.754L19,16.992l2.754,1.237,1.237,2.754,1.237-2.754,2.754-1.237-2.754-1.237Z"
            transform="translate(112.338 423.68)" fill="#fff"/>
      <path id="Pfad_4283" data-name="Pfad 4283"
            d="M20.587,13l-.492,1.095L19,14.587l1.095.492.492,1.095.492-1.095,1.095-.492-1.095-.492Z"
            transform="translate(84.258 445.918)" fill="#fff"/>
      <circle id="Ellipse_875" data-name="Ellipse 875" cx="5.82" cy="5.82" r="5.82"
              transform="translate(191.354 207.765) rotate(60)" fill="#e4e4e4"/>
      <circle id="Ellipse_876" data-name="Ellipse 876" cx="3.707" cy="3.707" r="3.707"
              transform="translate(284.287 501.363) rotate(60)" fill="#e4e4e4"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ScheduleOverviewEmptyState',
  data() {
    return {
      color: this.$vuetify.theme.currentTheme.primary,
    }
  }
}
</script>